import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hidden',
  pure: false
})
export class HiddenPipe implements PipeTransform {

  transform(fields: any, hidden?: string): any {
    fields = fields ? fields : [];
    return fields.filter(field => {
      // Use double equals because field.hidden is 0 or 1
      // Hidden arg is string 'true' or 'false'
      return field.hidden == hidden;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/hidden.pipe.ts